module.exports = __webpack_public_path__ + "static/media/CursedBoysandBrokenHearts.94c05714.jpg";